export enum ShopWebhookField {
  FiatCurrency = 'fiatCurrency',
  DisputeAmount = 'disputeAmount',
  StatusReason = 'statusReason',
  AssetCurrencyAmount = 'assetCurrencyAmount',
  ShopFee = 'shopFee',
  CurrencyRate = 'currencyRate',
}
